
import { Component, Mixins, Prop } from 'vue-property-decorator';
import NetatmoIcon from '~/components/NetatmoIcon.vue';
import { IconsConst } from '~/constants/Icons.constant';
import { displayData, safeTags } from '~/helpers';
import { FieldObject } from '~/interfaces/field.interface';
import { frontendToBackendKeysMap } from '~/maps/frontendToBackendKeys.map';
import FieldMixin from '~/mixins/field.mixin';
import { DevicesModule } from '~/store/modules/devices';

@Component({
    components: {
        NetatmoIcon,
    }
})
export default class Field extends Mixins(FieldMixin) {
    @Prop() readonly field!: FieldObject;

    get displayData() {
        return displayData(this.field);
    }

    get canBeConsideredDisconnected() {
        return DevicesModule.currentGateway?.canBeConsideredDisconnected;
    }

    get isFieldWithOverlay() {
        return this.field.icon && IconsConst.RoomsAssets[this.field.icon]?.length > 1;
    }

    get backendKey(): string | undefined {
        return frontendToBackendKeysMap.get(this.field.key);
    }

    safeTags(str: string) {
        return safeTags(str);
    }
}
